module.exports = __webpack_public_path__ + "static/media/file-upload-icon.0f277567.svg";